// extracted by mini-css-extract-plugin
module.exports = {"container":"DaysOfWeek_container_1Rykj","cell":"DaysOfWeek_cell_22a2y"};